import { FormProvider, useForm } from "react-hook-form";
import { useEffect } from "react";

import useAttachCloudIntegration from "shared/CloudIntegration/useAttachCloudIntegration";
import { CLOUD_INTEGRATIONS } from "shared/CloudIntegration/types";
import { GCP_INTEGRATION_DEFAULT_SCOPES } from "shared/CloudIntegration/constants";

import CardForm from "./CardForm";
import SubmitButton from "./SubmitButton";
import GCPScopesField from "./Fields/GCPScopesField";

type AttachCloudFormGCPIntegrationProps = {
  entityId: string;
  onSuccess: () => void;
  refetchQueries?: string[];
  onDirtyChange?: (isDirty: boolean) => void;
};

type FormValues = {
  scopes: Array<{ value: string }>;
};

const AttachCloudFormGCPIntegration = ({
  onDirtyChange,
  onSuccess,
  entityId,
  refetchQueries,
}: AttachCloudFormGCPIntegrationProps) => {
  const form = useForm<FormValues>({
    defaultValues: {
      scopes: GCP_INTEGRATION_DEFAULT_SCOPES.map((value) => ({ value })),
    },
  });

  const {
    handleSubmit,
    formState: { isDirty },
  } = form;

  const { attach } = useAttachCloudIntegration({
    entityId,
    onSuccess,
    refetchQueries,
  });

  useEffect(() => {
    onDirtyChange?.(isDirty);
  }, [isDirty, onDirtyChange]);

  const onSubmit = (data: FormValues) =>
    attach({
      type: CLOUD_INTEGRATIONS.GCP,
      scopes: data.scopes.map((scope) => scope.value),
    });

  return (
    <FormProvider {...form}>
      <CardForm onSubmit={handleSubmit(onSubmit)}>
        <GCPScopesField />
        <SubmitButton />
      </CardForm>
    </FormProvider>
  );
};

export default AttachCloudFormGCPIntegration;
